export const inspectTable = [
  {
    id: 1,
    content: '보일러 본체 외관상 이상한 오염이나 변색된 부분이 없는가?',
    is_checked: ''
  },
  {
    id: 2,
    content: '운전중 본체 표면의 과열된 부분은 없는가?',
    is_checked: ''
  },
  {
    id: 3,
    content: '보일러 각부의 플랜지, 유니온등의 연결부나 각배관 접속부의 연결상태는 견고한가?',
    is_checked: ''
  },
  {
    id: 4,
    content: '연소중, 물이나 증기누출, 제어반등 각부위 이상음은 없는가?★',
    is_checked: ''
  },
  {
    id: 5,
    content: '보일러부식, 보온재균열과 탈락상태는 없는가?',
    is_checked: ''
  },
  {
    id: 6,
    content: '전기배선에 이상은 없는가?',
    is_checked: ''
  },
  {
    id: 7,
    content: '압력계는 정상적으로 작동하는가?★',
    is_checked: ''
  },
  {
    id: 8,
    content: '압력이 지나치게 올라가거나 내려가는일은 없는가?',
    is_checked: ''
  },
  {
    id: 9,
    content: '규정 압력에서 보일러가 정지하는가?',
    is_checked: ''
  },
  {
    id: 10,
    content: '버너 점화에 이상은 없는가?',
    is_checked: ''
  },
  {
    id: 11,
    content: '불착화의 경우 경보부저가 울려 보일러 운전이 정지하는가?',
    is_checked: ''
  },
  {
    id: 12,
    content: '가스등의 누설은 없는가?',
    is_checked: ''
  },
  {
    id: 13,
    content: '점화나 연소시 이상한 소리나 냄새가 없는가?★',
    is_checked: ''
  },
  {
    id: 14,
    content: '노내가스의 프리퍼지나 포스트퍼지는 충분한가?',
    is_checked: ''
  },
  {
    id: 15,
    content: '송풍기와 댐퍼는 정상작동 되는가?',
    is_checked: ''
  },
  {
    id: 16,
    content: '보일러 주변에 인화성 물질이나 위험물은 없는가?★',
    is_checked: ''
  },
  {
    id: 17,
    content: '보일러실 조명과 환기는 충분한가?★',
    is_checked: ''
  },
  {
    id: 18,
    content: '저수위 등의 안전장치와 경보기는 정상작동하는가?★',
    is_checked: '',
  },
];
